export const LICENSE_VALIDITY_RANGES: Record<number, [number, number]> = {
  30: [28, 31],
  365: [365, 366],
  1095: [1095, 1098],
  1825: [1824, 1830]
};